/*
 * @Author: JamesWong
 * @Description: 仓库模块繁体包
 * @Date: 2018-11-29 18:56:25
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-12-17 11:23:22
 */
export default {
  authorizedWarehouse: '已授權倉庫',
  deleteWarehouse: '刪除倉庫',
  hint: '提示',
  deleteWarehouseTips: '刪除後該倉庫將不能使用POS登錄,確定刪除該倉庫嗎?',
  cancel: '取消',
  confirmDelete: '確定刪除',
  addWarehouse: '新增倉庫',
  addAuthorizedWarehouse: '新增授權倉庫',
  searchAuthorizedWarehouse: '搜索已授權店鋪',
  Order: '序號',
  warehouseNumber: '倉庫編號',
  warehouseAbbreviation: '倉庫簡稱',
  warehouseFullname: '倉庫全稱',
  confirm: '確定',
  searchWarehouse: '搜索倉庫',
  authorizedWarehouseAdded: '授權倉庫新增成功！',
  authorizedWarehouseDeleted: '授權倉庫刪除成功！'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/warehouse.js